import {Directive, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output} from '@angular/core';

@Directive({
    selector: '[dstClickOutside]',
    standalone: false
})
export class DSTClickOutsideDirective implements OnInit, OnDestroy {

  /**
   * When false, outside clicks are ignored without entering the Angular zone.
   * Grid rows bind this to their open-menu state so a single document click
   * does not trigger one full change-detection pass per row.
   */
  @Input() clickOutsideEnabled: boolean = true;
  // a string class name selector that represents the elements you want to ignore as the target of click event
  // @Input() clickOutsideIgnore: string | null;
  @Output() clickOutside: EventEmitter<void>;

  private readonly onDocumentClick = (event: MouseEvent): void => {
    if (!this.clickOutsideEnabled) {
      return;
    }
    // if (this.clickOutsideIgnore) {
    //   if (target.classList.contains(this.clickOutsideIgnore)) {
    //     return;
    //   }
    // }
    if (this.elementRef.nativeElement.contains(event.target)) {
      return;
    }
    this.ngZone.run(() => this.clickOutside.emit());
  };

  constructor(private elementRef: ElementRef, private ngZone: NgZone) {
    // this.clickOutsideIgnore = null;
    this.clickOutside = new EventEmitter<void>();
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      document.addEventListener('click', this.onDocumentClick);
    });
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.onDocumentClick);
  }
}
